/**
 * Side-by-side comparison with a historical style (JF 2026-09-29, requested by the boss; layout JF 2026-09-30):
 * the left half of the screen shows exactly the 历史 BOM tab — search, pictures, click one for its detail and BOM —
 * scaled down proportionally, next to the current cost sheet. No computed differences: the AM judges by eye.
 * Optional — opened with "Compare with history" on the cost sheet (or from a BOM's detail view).
 */
import { useEffect, useRef, useState } from "react";
import { useStore } from "../../store.ts";
import { useT } from "../../shared/i18n.ts";
import { BomBrowser } from "../bom-search/BomTab.tsx";

/** Width the 历史 BOM tab is laid out for; the panel shows it scaled to fit (never enlarged). */
const DESIGN_WIDTH = 1100; // half of a 1920 px screen → ≈ 0.8× (5 styles per row), still readable

export function Compare() {
  const t = useT();
  const { setCompare } = useStore.getState();
  const box = useRef<HTMLDivElement>(null);
  const [zoom, setZoom] = useState(1);
  useEffect(() => {
    const el = box.current;
    if (!el) return;
    const fit = () => setZoom(Math.min(1, Math.max(0.5, el.clientWidth / DESIGN_WIDTH)));
    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return (
    <aside className="cmp" id="cmpPanel">
      <div className="cmph">
        <b>{t("Historical styles", "历史款")}</b>
        <span className="lnk" style={{ marginLeft: "auto" }} onClick={() => setCompare({ on: false, sc: null })}>{t("Close", "关闭对比")} ×</span>
      </div>
      <div ref={box} className="cmpbox">
        <div className="cmpzoom" style={{ zoom }}><BomBrowser active mode="compare" /></div>
      </div>
    </aside>
  );
}
